document.addEventListener('DOMContentLoaded', () => {
  // Select all elements with the class 'childMenu'
  const childMenus = document.querySelectorAll('.childMenu');

  // Iterate through each 'childMenu' element
  childMenus.forEach(childMenu => {
    // Select all 'li' elements within the current 'childMenu'
    const liElements = childMenu.querySelectorAll('li');
    
    // Check if there are more than 5 'li' elements
    if (liElements.length > 5) {
      // Hide all 'li' elements after the 4th one
      for (let i = 4; i < liElements.length; i++) {
        liElements[i].style.display = 'none';
      }

      // Create the "Read More" list item
      const readMoreListItem = document.createElement('li');
      readMoreListItem.textContent = 'More';
      readMoreListItem.classList.add('read-more-less'); // Add class
      readMoreListItem.style.cursor = 'pointer';

      // Append the "Read More" list item after the 4th 'li' element
      liElements[3].parentNode.insertBefore(readMoreListItem, liElements[4]);

      // Add click event listener to the "Read More" list item
      readMoreListItem.addEventListener('click', (event) => {
        // Prevent default list item behavior
        event.preventDefault();
        // Show all hidden 'li' elements
        for (let i = 4; i < liElements.length; i++) {
          liElements[i].style.display = 'list-item';
        }
        // Hide the "Read More" list item
        readMoreListItem.style.display = 'none';
        // Show the "Read Less" list item
        readLessListItem.style.display = 'list-item';
      });

      // Create the "Read Less" list item
      const readLessListItem = document.createElement('li');
      readLessListItem.textContent = 'Less';
      readLessListItem.classList.add('read-more-less'); // Add class
      readLessListItem.style.display = 'none';
      readLessListItem.style.cursor = 'pointer';

      // Append the "Read Less" list item after the last 'li' element
      childMenu.appendChild(readLessListItem);

      // Add click event listener to the "Read Less" list item
      readLessListItem.addEventListener('click', (event) => {
        // Prevent default list item behavior
        event.preventDefault();
        // Hide extra 'li' elements
        for (let i = 4; i < liElements.length; i++) {
          liElements[i].style.display = 'none';
        }
        // Show the "Read More" list item
        readMoreListItem.style.display = 'list-item';
        // Hide the "Read Less" list item
        readLessListItem.style.display = 'none';
      });
      
      // Prevent details element from toggling when clicking list items
      [readMoreListItem, readLessListItem].forEach(listItem => {
        listItem.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      });
    }
  });
});
